import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Input, Button, Alert } from '../components/design-system';
import { Mail, ArrowLeft, Truck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import accountService from '../services/accountService';

export const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await accountService.requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || t('auth.forgotPassword.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-accent-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-xl p-6">
          <div className="flex justify-center mb-6">
            <div className="h-16 w-16 bg-primary-500 rounded-2xl flex items-center justify-center shadow-lg shadow-primary-500/30">
              <Truck className="h-8 w-8 text-white" />
            </div>
          </div>

          {success ? (
            <div className="text-center">
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                {t('auth.forgotPassword.successTitle')}
              </h2>
              <p className="text-sm text-gray-600 mb-6">
                {t('auth.forgotPassword.successMessage', { email })}
              </p>
              <Link
                to="/login"
                className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm"
              >
                <ArrowLeft className="h-4 w-4" />
                {t('auth.forgotPassword.backToLogin')}
              </Link>
            </div>
          ) : (
            <>
              <div className="text-center mb-6">
                <h1 className="text-xl font-bold text-gray-900 mb-1">
                  {t('auth.forgotPassword.title')}
                </h1>
                <p className="text-sm text-gray-600">
                  {t('auth.forgotPassword.description')}
                </p>
              </div>

              {error && (
                <Alert variant="error" className="mb-4" dismissible onDismiss={() => setError('')}>
                  {error}
                </Alert>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                  label={t('auth.email')}
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  leftIcon={<Mail className="h-5 w-5 text-gray-400" />}
                  autoComplete="email"
                  required
                  fullWidth
                />

                <Button type="submit" fullWidth loading={loading} size="lg">
                  {t('auth.forgotPassword.sendResetLink')}
                </Button>
              </form>

              <div className="mt-4 text-center">
                <Link
                  to="/login"
                  className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm"
                >
                  <ArrowLeft className="h-4 w-4" />
                  {t('auth.forgotPassword.backToLogin')}
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
